import { api, setCSRFToken } from './api.svelte.js';
import { describeLoginError } from './login-errors.js';

const SESSION_KEY = 'smacos.session';

function loadSession() {
  if (typeof localStorage === 'undefined') return { role: 'guest', nick: '' };
  try {
    const saved = JSON.parse(localStorage.getItem(SESSION_KEY) ?? '{}');
    return saved.role === 'admin' ? { role: 'admin', nick: saved.nick ?? 'admin' } : { role: 'guest', nick: saved.nick ?? '' };
  } catch {
    return { role: 'guest', nick: '' };
  }
}

export const session = $state(loadSession());

function persist() {
  if (typeof localStorage === 'undefined') return;
  localStorage.setItem(SESSION_KEY, JSON.stringify(session));
}

// Resolves to { ok } on success, or { ok: false, twoFactorRequired, error } so
// the caller can ask for an authenticator code or show why login failed.
export async function loginAdmin(password, code) {
  try {
    const res = await api.login(password, code);
    if (res.csrf) setCSRFToken(res.csrf);
    session.role = 'admin';
    session.nick = 'admin';
    persist();
    return { ok: true };
  } catch (err) {
    return { ok: false, ...describeLoginError(err, code) };
  }
}

export async function verifySession() {
  try {
    const res = await api.verify();
    if (res.authenticated) {
      session.role = 'admin';
      session.nick = 'admin';
      if (res.csrf) setCSRFToken(res.csrf);
      persist();
    }
  } catch {
    // stays guest
  }
}

export async function logoutAdmin() {
  try {
    await api.logout();
  } catch {
    // best-effort
  }
  setCSRFToken(null);
  session.role = 'guest';
  session.nick = '';
  persist();
}

export function loginGuest() {
  session.role = 'guest';
  session.nick = '';
  persist();
}

export function isAdmin() {
  return session.role === 'admin';
}

export function shutdownOS() {
  localStorage.clear();
  sessionStorage.clear();
  setCSRFToken(null);
  session.role = 'guest';
  session.nick = '';
  globalThis.dispatchEvent(new CustomEvent('os-power', { detail: { action: 'shutdown' } }));
}

export function restartOS() {
  localStorage.clear();
  sessionStorage.clear();
  setCSRFToken(null);
  session.role = 'guest';
  session.nick = '';
  globalThis.dispatchEvent(new CustomEvent('os-power', { detail: { action: 'restart' } }));
}
